import {
  getRegion,
  updateMultiCountryRegion,
  multiCountryPlugin,
  AvailableRegion,
} from './multi-country';

export type { MultiCountryProps } from './multi-country';

interface I18nPlugin {
  type: string;
  name: string;
  [key: string]: any;
}
const registerI18nPlugin = (i18nInstance: any, plugin: I18nPlugin) => {
  if (!i18nInstance || !i18nInstance.use || !i18nInstance.options) {
    throw new Error(
      'i18nInstance lacks of necessary properties with use && options',
    );
  }
  i18nInstance.use(plugin);
  // Jupiter 4 BUG: overrider jupiter.config.js i18nOptions with App.features.i18n, add postProcess
  if (plugin.type === 'postProcessor') {
    if (typeof i18nInstance.options?.postProcess === 'string') {
      if (i18nInstance.options.postProcess !== plugin.name) {
        i18nInstance.options.postProcess = [
          i18nInstance.options.postProcess,
          plugin.name,
        ];
      }
    } else if (Array.isArray(i18nInstance.options.postProcess)) {
      if (!i18nInstance.options.postProcess.includes(plugin.name)) {
        i18nInstance.options.postProcess.push(plugin.name);
      }
    } else {
      i18nInstance.options.postProcess = [plugin.name];
    }
  }
};

const I18nPluginFactory = {
  AvailableRegion,
  getRegion,
  registerI18nPlugin,
  updateMultiCountryRegion,
  multiCountryPlugin,
};

export default I18nPluginFactory;
